import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './LinkedReturnsTable.module.scss';

export interface LinkedReturn {
  reference: string;
  id?: number | null;
  name?: string | null;
}

export interface LinkedReturnsTableProps {
  returns: LinkedReturn[];
  onReturnClick?: (returnId: number) => void;
}

const LinkedReturnsTable: React.FC<LinkedReturnsTableProps> = ({ returns, onReturnClick }) => {
  const { t } = useTranslation();

  if (!returns.length) return null;

  const handleRowClick = (linkedReturn: LinkedReturn) => {
    if (linkedReturn.id && onReturnClick) {
      onReturnClick(linkedReturn.id);
    }
  };

  return (
    <div className={classNames(styles.root, 'mb-16')}>
      <table>
        <thead>
          <tr>
            <th className="typo-text-12 text-faded">{t('general.term')}</th>
          </tr>
        </thead>
        <tbody>
          {returns.map(linkedReturn => (
            <tr
              key={linkedReturn.reference}
              className={classNames(styles.linkedReturn, {
                'cursor-pointer hover:surface-elevated-more': !!linkedReturn.id,
              })}
              onClick={() => handleRowClick(linkedReturn)}>
              <td>
                <h4 className={classNames('typo-text-14--bold', linkedReturn.id ? 'text-full' : 'text-faded')}>
                  {linkedReturn.name || linkedReturn.reference}
                </h4>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LinkedReturnsTable;
